// These are Actions and Not Action Creators.
// The name of this page must be updated to actions.js but not now

// actions
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CLOSE_MODAL = 'CLOSE_MODAL';
